import { createMuiTheme } from "@material-ui/core/styles";

const aceBlue = "#06b";
const theme = createMuiTheme({
  typography: {
    fontFamily: "verdana,arial,sans-serif",
    fontSize: 15,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  palette: {
    text: "#000",
    primary: { main: aceBlue },
    secondary: { main: aceBlue },
  },
  overrides: {
    MuiListItemIcon: {
      color: "#000",
    },
    MuiSvgIcon: {
      colorPrimary: {
        color: "#000",
      },
    },
    MuiTab: {
      label: {
        fontWeight: "bold",
      },
    },
    MuiIcon: {
      colorPrimary: {
        color: "#000",
      },
    },
    MuiTable: {
      root: {
        padding: "15px 0 15px 0",
      },
    },
    MuiTableRow: {
      head: {
        height: 30,
      },
    },
    MuiTableCell: {
      head: {
        fontSize: 15,
        fontWeight: 700,
        color: "#fff",
        backgroundColor: aceBlue,
      },
      body: {
        fontSize: 15,
        textAlign: "center",
        border: "1px solid #e5e5e5",
      },
    },
    MuiTableHead: {
      root: {
        height: 30,
      },
    },

    MuiDialogTitle: {
      root: {
        color: "#fff",
        backgroundColor: aceBlue,
      },
    },
    MuiTypography: {
      title: {
        color: "#fff",
      },
      display1: {
        fontSize: "1.8rem",
      },
    },
    MuiCheckbox: {
      root: {
        color: aceBlue,
      },
      checked: {
        color: aceBlue,
      },
      colorPrimary: {
        color: aceBlue,
      },
      colorSecondary: {
        color: aceBlue,
      },
    },
  },
});

export default theme;
